import React from 'react'
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts'
import { Legend } from '@src/containers/Visualisation/components'

import * as Styled from './SowingExpensesChart.styled'

type Props = {
  data?: Record<string, number>
  graphHeight?: number
}

const RADIAN = Math.PI / 180

const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5
  const x = cx + radius * Math.cos(-midAngle * RADIAN)
  const y = cy + radius * Math.sin(-midAngle * RADIAN)

  return (
    <text
      x={x}
      y={y}
      fill="#292E3D"
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  )
}

const NAME_TO_COLOR_MAP = {
  top5: '#D7ACF6',
  rest: '#68E9BE'
}

const SowingExpensesChart: React.FC<Props> = ({ data, graphHeight }) => {
  const formattedData = data
    ? Object.entries(data).map(([name, value]) => ({ name, value }))
    : undefined

  return (
    <Styled.FlexContainer>
      <Styled.ResponsiveContainer as={ResponsiveContainer} width={'50%'} height={graphHeight}>
        <PieChart width={graphHeight} height={graphHeight}>
          <Pie
            data={formattedData}
            cx="50%"
            strokeWidth={4}
            stroke="#F5F7FF"
            cy="50%"
            labelLine={false}
            label={renderCustomizedLabel}
            cornerRadius={5}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {formattedData?.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={NAME_TO_COLOR_MAP[entry.name] ?? '#fff'} />
            ))}
          </Pie>
        </PieChart>
      </Styled.ResponsiveContainer>
      <Legend
        Container={Styled.LegendContainer}
        data={[
          { color: NAME_TO_COLOR_MAP.top5, title: 'Топ 5' },
          { color: NAME_TO_COLOR_MAP.rest, title: 'Остальные' }
        ]}
        hasData={!!formattedData}
      />
    </Styled.FlexContainer>
  )
}

export default SowingExpensesChart
